export default "__VITE_ASSET__0603412b__"